import Event from 'events';
import Utils from 'Utils';
import request from 'request';

/**
 * 调用后台接口时要求:
 * 如果是线上版本则只需要传 extUuid
 * 如果是非线上版本则需要传 extUuid 和 extVersionId
 * state: -1, 未知; 0, 已安装; 1, 未安装;
 * 分为三种类型的安装 1. 安装免安装费和测试版的小程序 2. 安装费 3. 服务费
 */
class Install extends Event {
  constructor({extUuid, extVersionId, extVersionOnline}, defaultState = -1) {
    super()

    extVersionId = extVersionOnline == 1 ? undefined : extVersionId

    const self = this

    self.state = self.defaultState = defaultState

    self._in = () => {
      if (self.state != 0) {
        self.emit('change', self.state = 0)
      }
    }

    self._un = () => {
      if (self.state != 1) {
        self.emit('change', self.state = 1)
      }
    }


    /**
         * @param isCoverInstall 是否直接覆盖安装，只对非正式版本有效 0为正常安装 1为覆盖安装
         */
    self.in = (isCoverInstall = 0) => request({
      type: 'POST',
      url: request.api.installExt,
      data: {extUuid, extVersionId, isCoverInstall},
    })
      .done(self._in)

    /**
         * @param isFromFreeChangeConfirm 尤龙的上报需求, 对于来自freechangeconfirm 的调用区别对待
         */
    self.un = (isFromFreeChangeConfirm = false) => {
      const data = {
        extUuid,
        extVersionId,
      }

      if (isFromFreeChangeConfirm) {
        data.rejectFeeChange = 1;
      }

      return request({
        type: 'POST',
        url: request.api.uninstallExt,
        data,
      })
        .done(self._un)
    }

    self.toggle = () => (self.state == 0 ? self.un() : self.in())

    self.forceInstall = () => {
      const isCoverInstall = 1; // 覆盖安装

      return self.in(isCoverInstall);
    }

    self.setInstallState = state => {
      self.state = state;
    }

    self.fetchRemoteState = useBat => {
      let req = null

      // 批量查询
      if (useBat) {
        req = fetchInstallList().then(installList => {
          const list = installList.filter(item => {
            if (extVersionId) {
              return extUuid == item.extUuid && extVersionId == item.extVersionId
            } else {
              return extUuid == item.extUuid
            }
          })

          return list.length > 0
        })
      } else {
        req = request({
          type: 'GET',
          url: request.api.hadInstall,
          data: {extUuid, extVersionId},
        })
      }

      return req.done(bState => self[bState ? '_in' : '_un']())
    }

    self.on('change', state => {
      const index = installList.findIndex(item => {
        if (extVersionId) {
          return extUuid == item.extUuid && extVersionId == item.extVersionId
        } else {
          return extUuid == item.extUuid
        }
      })

      if (state) {
        if (index == -1) {
          installList.push({extUuid, extVersionId})
        }
      } else {
        if (index != -1) {
          installList.splice(index, 1)
        }
      }
    })
  }
}

const installList = []

const fetchInstallList = Utils.once(() => request({
  type: 'GET',
  url: request.api.extInstallList,
})
  .then(list => {
    installList.length = 0;

    (list && list.length ? list : []).forEach(item => installList.push(item));

    return installList;
  }))

export default Install;